/**
 * Export component file to be used on project
 */

import FloatActionButtonDesktop from './FloatActionButtonDesktop';
export default FloatActionButtonDesktop;